import { Grid } from '@mui/material'
import { Modal } from 'components/core-ui/Modal'
import { Button } from '@fullscreendigital/carrefour-dex-fe'
import s from 'components/core-ui/Modal/Modal.modules.scss'

const SignReportConfirmationModal = ({ isModalOpen, closeModal, onSign }) => {
  return (
    <Modal isModalOpen={isModalOpen} closeModal={closeModal} modalTitle="Semnare raport zilnic">
      <Grid container spacing={4}>
        <Grid xs={12} item className={s.modalMessage}>
          Esti sigur ca vrei sa setezi acest raport ca fiind semnat?
        </Grid>

        <Grid xs={12} item className={s.modalButtons}>
          <Button variant="outlined" label="Anuleaza" onClick={() => closeModal()} />
          <Button variant="contained" label="Semneaza" onClick={onSign} />
        </Grid>
      </Grid>
    </Modal>
  )
}

export default SignReportConfirmationModal
